<template>
  <div class="loading">
    <img src="@/assets/imgs/loading/star.png" class="loading__star bling">
    <div class="loading__cnt">
      <div class="loading__cnt__img fadeInLeftFixed">
        <img src="@/assets/imgs/loading/people.png" class="loading__cnt__img__people animated fadeInLeft2">
        <img src="@/assets/imgs/loading/car.png" class="loading__cnt__img__car animated fadeIn">
      </div>
      <div class="loading__cnt__progress animated fadeInUp">
        <div :style="`width: ${progress}%;`"></div>
      </div>
      <div class="loading__cnt__percent animated fadeInUp">
        <count-to :startVal="lastProgress" :endVal="newProgress" :duration="300"></count-to>
        <span>%</span>
      </div>
      <img src="@/assets/imgs/loading/text.png" class="loading__cnt__text animated fadeInUp">
    </div>
    <img src="@/assets/imgs/loading/logo.png" class="loading__logo animated fadeInUp">
  </div>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  props: ['progress'],
  components: {
    countTo
  },
  computed: {
    imgX() {
      return (this.progress - 50) / 4
    }
  },
  data() {
    return {
      lastProgress: 0,
      newProgress: 0
    }
  },
  watch: {
    progress(newVal, oldVal) {
      this.lastProgress = oldVal
      this.newProgress = newVal
    }
  }
}
</script>

<style lang="scss">
@import '~@/style/mixin.scss';

.loading {
  @include fullscreen;
  @include bg-cover;
  z-index: 1000;
  background-image: url("~@/assets/imgs/loading/bg.png");
  text-align: center;
  color: #dddfee;
  &__star {
    @include transform-center;
    width: 5.8rem;
    z-index: 1;
  }
  &__cnt {
    @include transform-center;
    top: 45%;
    z-index: 2;
    &__img {
      height: 1.22rem;
      position: relative;
      width: 100%;
      transform: translate3d(-100%, 0, 0);
      &__car {
        animation-delay: .5s;
        position: absolute;
        left: 50%;
        margin-left: -2.1rem;
        bottom: 0;
        height: .99rem;
      }
      &__people {
        animation-delay: 3s;
        position: absolute;
        bottom: .06rem;
        left: 50%;
        margin-left: -1.7rem;
        height: 100%;
        z-index: 1;
      }
    }
    &__progress {
      animation-delay: 1.3s;
      margin-top: .33rem;
      background: #dddfee;
      height: .08rem;
      border-radius: .04rem;
      width: 4.58rem;
      div {
        @include transition-fast;
        background: #fe8449;
        height: 100%;
        border-radius: .04rem;
      }
    }
    &__percent {
      animation-delay: 1.5s;
      margin-top: .26rem;
      span {
        display: inline-block;
        vertical-align: bottom;
        font-size: .24rem;
        &:first-child {
          font-size: .58rem;
          line-height: .58rem;
        }
      }
    }
    &__text {
      animation-delay: 1.7s;
      margin-top: .1rem;
      width: 1.3rem;
    }
  }
  &__logo {
    animation-delay: 2s;
    position: absolute;
    left: 50%;
    margin-left: -.95rem;
    width: 1.9rem;
    bottom: 1.04rem;
    z-index: 3;
  }
}
</style>